import $ from "jquery";
import 'bootstrap/js/dist/tooltip';

if (document.querySelector(".header-dropdown")) {
    const headerDropdowns = document.querySelectorAll(".header-dropdown");
    headerDropdowns.forEach(headerDropdown => {
        $(headerDropdown.querySelector("select")).select2({
            minimumResultsForSearch: Infinity,
            dropdownParent: $(headerDropdown.querySelector(".header-dropdown__dropdown-wrapper"))
        });

        $(headerDropdown.querySelector(".header-dropdown__slider")).slick({
            arrows: false
        });
        headerDropdown.querySelector("select").onchange = e => {
            window.location.href = e.target.value;
        }
    });

    $(".select2-container").tooltip({
        title: function() {
            return $(this).prev().attr("title");
        },
        placement: "auto",
    });
}